import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const ZeroNotifications: React.FC = () => {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "flex h-48 w-full flex-col items-center justify-center gap-1.5",
        theme.home.tailwind.textDefault,
      )}
    >
      <div className="leading-6] break-words text-center text-lg font-bold">No notifications</div>
      <div className="break-words text-center text-base font-normal leading-5">Notifications will show up here</div>
    </div>
  );
};

export default ZeroNotifications;
